<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.contractors')}}</v-list-item-title>
    <VfAutoSelect
      :items="contractors"
      v-model="selectedContractorsModel"
      nameField="companyName"
      valueField="id"
      hide-details
      allowSingleDelete
      :placeholder="$t('insights.filters.contractorsPlaceholder')"
      class="pb-1 pt-3 insights-filter-input-text full-width"
    />
  </v-list-item>
</template>

<script>
export default {
  name: 'ContractorsFilter',
  props: {
    contractors: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedContractors: {
      type: Array
    }
  },
  emits: ['selectedContractorsInput'],
  data () {
    return {

    }
  },
  computed: {
    selectedContractorsModel: {
      get () {
        return this.selectedContractors
      },
      set (value) {
        this.$emit('selectedContractorsInput', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
